<template>
  <div class="navmenu">
    <div class="footercontents contents">
      <div>
        <el-row>
          <el-col :span="7">
            <html-text message="产品中心"></html-text>
            <el-row>
              <el-col :span="8">
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 1, classid: 0, classname: 'RV减速机' }
                  }"
                >
                  <html-text-small message="RV减速机" />
                </router-link>
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 2, classid: 0, classname: '伺服电机' }
                  }"
                >
                  <html-text-small message="伺服电机" />
                </router-link>
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 3, classid: 0, classname: '伺服驱动器' }
                  }"
                >
                  <html-text-small message="伺服驱动器" />
                </router-link>
              </el-col>
              <el-col :span="8" style="margin-left: -4px;">
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 4, classid: 0, classname: '并联机器人' }
                  }"
                >
                  <html-text-small message="并联机器人" />
                </router-link>
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 6, classid: 0, classname: '串联机器人' }
                  }"
                >
                  <html-text-small message="串联机器人" />
                </router-link>
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 7, classid: 0, classname: '协作机器人' }
                  }"
                >
                  <html-text-small message="协作机器人" />
                </router-link>
              </el-col>
              <el-col :span="8" style="margin-left: -8px;">
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 8, classid: 0, classname: '真空元件' }
                  }"
                >
                  <html-text-small message="真空元件" />
                </router-link>
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 9, classid: 0, classname: '控制系统' }
                  }"
                >
                  <html-text-small message="控制系统" />
                </router-link>
                <router-link
                  :to="{
                    name: 'goodslist',
                    params: { pid: 10, classid: 0, classname: '机器视觉系统' }
                  }"
                >
                  <html-text-small message="机器视觉系统" />
                </router-link>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="3" style="margin-left: -12px;">
            <html-text message="客户服务"></html-text>
            <router-link :to="{ name: 'helppurchase', params: { id: 6 } }">
              <html-text-small message="我要采购" />
            </router-link>
            <router-link :to="{ name: 'helpcooperation' }">
              <html-text-small message="供应商合作" />
            </router-link>
            <router-link :to="{ name: 'helpfqa' }">
              <html-text-small message="帮助中心" />
            </router-link>
          </el-col>
          <el-col
            :span="4"
            style="margin-left: -20px;
}"
          >
            <html-text message="关于我们"></html-text>
            <router-link :to="{ name: 'contacus' }">
              <html-text-small message="关于MOVIBOT" />
            </router-link>
            <a target="_blank" href="https://www.sjyuan.net.cn"
              ><html-text-small message="设纪元"
            /></a>

            <a target="_blank" href="https://www.tjchenxing.com"
              ><html-text-small message="天津阿童木机器人股份有限公司"
            /></a>
            <!--<html-footer-img />-->
          </el-col>
          <el-col class="verbox" :span="1">
            <el-divider class="verticalline" direction="vertical"> </el-divider>
          </el-col>

          <el-col class="footer-right" :span="7">
            <html-text-and-img
              message="400-653-7789"
              imageurl="/static/icon/phone.png"
              imagewidth="25px"
              isemail="3"
            />
            <html-text-and-img
              message="155-2241-5492"
              isemail="0"
              imageurl="/static/icon/header.png"
              imagewidth="25px"
            />
            <html-text-and-img
              message="public@tjchenxing.com"
              isemail="1"
              imageurl="/static/icon/email.png"
              imagewidth="25px"
            />
            <p class="footer-right-info">
              服务时间：8:30-17:30(周一至周六，法定节假日除外）
            </p>
          </el-col>
          <el-col class="footer-img" :span="2">
            <img
              style="width: 111px;"
              src="@/assets/images/customerservice2.png"
            />
            <p>客服微信号</p>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-row>
      <el-col :span="24">
        <div class="record">
          Copyright©2023 MOVIBOT movibot-art.com
          <a href="https://beian.miit.gov.cn/">津ICP备17008102号-3</a
          ><!-- <span class="line">|</span> <a href="http://www.beian.gov.cn/portal/registerSystemInfo"><img :src="gongAnImg">津公网安备 12011602001036号</a>-->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HtmlFooterImg from "./htmlFooterImg.vue";
import HtmlText from "./HtmlText.vue";
import HtmlTextAndImg from "./HtmlTextAndImg.vue";
import HtmlTextSmall from "./HtmlTextSmall.vue";
export default {
  data() {
    return {
      gongAnImg: "/static/icon/gongan.png"
    };
  },
  components: { HtmlText, HtmlTextSmall, HtmlFooterImg, HtmlTextAndImg }
};
</script>

<style scoped>
.footercontents {
  padding-bottom: 59px;
}
.navmenu {
  background-color: #2655ae;
}
.verbox {
  text-align: center;
}
.verbox .verticalline {
  margin-top: 40px;
  height: 126px;
  background-color: #3c66b6;
  width: 2px;
}
.footer-right {
  margin-top: 31px;
  margin-left: 8px;
  /* width: 442px;
  float: right; */
}
.footer-img {
  margin-top: 31px;
  width: 111px;
  float: right;
}
.footer-img img {
  margin-top: 20px;
}
.footer-img p {
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-top: 8px;
}
.footer-right-info {
  font-size: 14px;
  line-height: 18px;
  color: #becce7;
  margin-top: 20px;
}
.record {
  text-align: center;
  background-color: #2b2b2b;
  font-size: 12px;
  line-height: 48px;
  color: #fff;
  height: 48px;
}
.record a {
  color: #fff;
}
.record span {
  margin: 0 10px;
}
.record img {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HtmlFooter.vue